###
  Tooltip crud widget
###

class INTENT.widgets.TooltipCrud

  @MODAL: "#modal_container"

  @ATTR_NAME: "data-widget-crud-tooltip"

  @ATTR_ROW: "#{@ATTR_NAME}-row"
  @ATTR_ROW_FORM: "#{@ATTR_ROW}-form"

  constructor: (@el) ->
    @s = @.constructor
    @el.on "submit", "form[#{@s.ATTR_ROW_FORM}]", @submit_row

  submit_row: (e) =>
    self = @
    form = $(e.currentTarget)

    request = $.ajax({
      url: form.attr("action"),
      type: form.attr("method"),
      data: form.serialize(),
      dataType: "json"
    });

    request.done (xhr) ->
      self.success_submit_row(form, xhr)

    return false

  success_submit_row: (form, xhr) =>
    INTENT.widgets.TooltipCrud.close_modal()

  @close_modal: ->
    @modal.modal('hide')

  @show_modal: (data)->
    unless @modal then @modal = $ INTENT.widgets.TooltipCrud.MODAL
    @modal.html data
    @modal.modal()



###
  TooltipEditor widget
###

class INTENT.widgets.TooltipEditor

  @ATTR_NAME: "data-widget-tooltip-pop"

  constructor: (@el) ->
    @s = @.constructor

    @el.on "dblclick", =>

      request = $.ajax({
        url: "/admin/tooltips/get_modal?code=#{@get_code()}",
        type: "get",
        dataType: "html"
      });

      request.done (data) =>
        INTENT.widgets.TooltipCrud.show_modal(data)

  get_code: =>
    @el.attr @s.ATTR_NAME